import * as React from "react";
import * as classnames from "classnames";
var Avatar = function (_a) {
    var children = _a.children, _b = _a.size, size = _b === void 0 ? "md" : _b, _c = _a.square, square = _c === void 0 ? false : _c, _d = _a.color, color = _d === void 0 ? null : _d;
    var _e;
    var classNames = classnames("wds-avatar", "wds-avatar--" + size, { "wds-avatar--square": square }, (_e = {}, _e["wds-avatar--" + color] = !!color, _e));
    return (React.createElement("span", { className: classNames },
        React.createElement("span", { className: "wds-avatar__body" }, children)));
};
export default Avatar;
//# sourceMappingURL=Avatar.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@sm/smapply-ui/dist/es/components/Avatar/Avatar.js
// module id = 1758
// module chunks = 17